'use strict';
import CryptoJS from 'crypto-js';

const EXTENSION_TIMESTAMP_THRESHOLD = 1200000; // 2 minutes
const EXTENSION_SECRET_KEY = 'key'; // secret key

export function encryptSecret (message: string) {
  return CryptoJS.AES.encrypt(message, EXTENSION_SECRET_KEY).toString();
}

export function decryptSecret (code: string) {
  return CryptoJS.AES.decrypt(code, EXTENSION_SECRET_KEY).toString(CryptoJS.enc.Utf8);
}

export function checkTimestampDelta (timestamp: number) {
  const now = Date.now();
  return (now - timestamp) <= EXTENSION_TIMESTAMP_THRESHOLD;
}
